import Ajax from '../../common/ajax'

const SearchApi = () => {
  let ajax = Ajax()

  const search = (term, filter = {}) => {
    console.log(`[search] ${term}`, filter)

    return ajax.post(window.wwp3.ajaxurl, {
      action: 'wwp3_search',
      ajaxcall: true,
      data: {
        term,
        filter: JSON.stringify(filter),
      },
    })
  }
  return {
    search,
  }
}

export default SearchApi



// WEBPACK FOOTER //
// src/assets/js/front-end/apps/search/search-api.js